import type { RelatedContentItem } from '@ilteducation/similar-content';
import { BookWithRelatedContents } from '@ilteducation/videos';
import { configHelper } from '@ilteducation/config';

const audioAidUrl = configHelper.getAppUrl('inlasta', 'ilteducation.se');
const bookDeepLinkUrl = (book: BookWithRelatedContents, item: RelatedContentItem) => {
  if (book.languages.secondaryLanguage) {
    return `${audioAidUrl}/books/${book.id}/read?reauthenticate=auto&heading=${encodeURIComponent(
      item.metadata!.title as string,
    )}`;
  }
  return `${audioAidUrl}/books/${book.id}/read?reauthenticate=auto&position=${item.metadata!.epubCfi}`;
};

export default bookDeepLinkUrl;
